import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CourseExports } from '../../../../../../pages/project/settings/CourseExports';
import { RoutePending } from '../../../../../../components/molecules/loader/RoutePending';
import { getProjectCourseExportsQueryOptions } from '../../../../../../rest-api/queries/sharedQueries';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/course-exports')({
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(getProjectCourseExportsQueryOptions(context.apiClient, params.project_id));
  },
  component: CourseExportsRoute,
  pendingComponent: () => <RoutePending label="Loading exports..." />,
});

function CourseExportsRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <CourseExports projectId={project_id} portalApiClient={apiClient} />;
}
